export default "__VITE_ASSET__CtIOYx2e__"